import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api, { GenericError } from "../api"
import { CreateUserRequest, UpdateUserRequest, UserModel } from "../api/user.api"

export interface UsersListState {
    users: UserModel[]
    loading: boolean
    //TODO: make error interface
    error?: GenericError
    success?: boolean
}

const initialState: UsersListState = {
    users: [],
    loading: false
}

export const loadUsers = createAsyncThunk(
    "users/list",
    async ({ warehouse }: { warehouse?: string }, thunkAPI) => {
        try {
            const response = await api.user.usersList({ warehouse })

            return response
        } catch (error: any) {
            console.log(error)

            return error.message
        }
    }
)

export const createUser = createAsyncThunk("users/create", async (newUserData: CreateUserRequest, thunkAPI) => {
    try {
        const response = await api.user.createUser(newUserData)

        return response
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const updateUser = createAsyncThunk(
    "users/update",
    async (existingUserData: UpdateUserRequest, thunkAPI) => {
        try {
            const response = await api.user.updateUser(existingUserData)

            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const usersSlice = createSlice({
    name: "users",
    initialState,

    reducers: {
        clearError: (state: UsersListState) => {
            state.error = undefined
        },
        resetSuccess: (state: UsersListState) => {
            state.success = undefined
        }
    },

    extraReducers: {
        [loadUsers.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadUsers.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.data?.data?.error) {
                state.error = action.payload?.data?.data?.error
            } else {
                state.error = action.payload?.data?.data?.payload
            }
        },
        [loadUsers.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.users = action.payload?.data?.data?.payload || []
        },

        [createUser.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [createUser.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [createUser.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
        },

        [updateUser.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [updateUser.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [updateUser.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
        }
    }
})

export const { clearError, resetSuccess } = usersSlice.actions

export default usersSlice.reducer
